module.exports = __webpack_public_path__ + "img/user-white-icon.56ee2bce.svg";